// <og-variant-refresh data-og-refresh="key"> — re-renders an Overground
// block's server output when the shopper picks another size. Horizon only
// morphs the variant picker itself and leaves other blocks to listen for
// the product-select event (see product-inventory.js); this is that listener
// for our blocks whose content depends on the selected variant
// (made-to-order note, trust row). The new markup comes from the section
// HTML the variant picker already fetched — no extra request.
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class OgVariantRefresh extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;
        const key = CSS.escape(this.dataset.ogRefresh ?? '');
        const next = detail.html.querySelector(`og-variant-refresh[data-og-refresh="${key}"]`);
        if (next) morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[og-variant-refresh]', error);
      });
  };
}

if (!customElements.get('og-variant-refresh')) {
  customElements.define('og-variant-refresh', OgVariantRefresh);
}
